<template>
  <p class="file-media__item__desc">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'FileMediaItemDescription',
};
</script>

<style lang="scss">
.file-media__item__desc {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/FileMediaItemDescription.vue